module.exports = __webpack_public_path__ + "static/media/telecomunicaciones-200x200.38208f31.png";